import type { ContactField } from "./types";

/**
 * Replace each googleItemId after running listFormItems() in Apps Script.
 * A value of 0 is accepted during local design work but rejected in production.
 */
export const contactFields: ContactField[] = [
  {
    key: "fullName",
    googleItemId: 1633920210,
    type: "text",
    label: "Full name",
    placeholder: "Your name",
    autocomplete: "name",
    required: true,
    minLength: 2,
    maxLength: 100,
  },
  {
    key: "email",
    googleItemId: 227649005,
    type: "email",
    label: "Email address",
    placeholder: "you@example.com",
    autocomplete: "email",
    required: true,
    maxLength: 254,
  },
  {
    key: "company",
    googleItemId: 861524984,
    type: "text",
    label: "Company",
    placeholder: "Company name (optional)",
    autocomplete: "organization",
    required: false,
    maxLength: 120,
  },
  {
    key: "message",
    googleItemId: 1846923513,
    type: "textarea",
    label: "Message",
    placeholder: "Tell me a little about what you have in mind…",
    autocomplete: "off",
    required: true,
    minLength: 10,
    maxLength: 3000,
  },
];
